module.exports = __webpack_public_path__ + "static/scale-model-of-denver-colorado-0cb3a343e46cc49f2e9abd5a77c8d542.png";